export default __webpack_public_path__ + "static/media/fidelity-national-logo.ae9fec83.jpg";